import { ADMINISTRATION_PAGE_URL } from '../../../const/routes';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { ADMINISTRATION_DATA_TYPE } from './AdministrationItemsFormFields';
import {
  ACCOUNT_NUMBER_FIELD_TYPE,
  BOOLEAN_FIELD_TYPE,
  CODE_FIELD_TYPE,
  COLOR_FIELD_TYPE,
  DATE_FIELD_TYPE,
  DATE_TIME_FIELD_TYPE,
  DAY_FIELD_TYPE,
  DICTIONARY_FIELD_TYPE,
  MULTI_SELECT_FIELD_TYPE,
  NUMBER_FIELD_TYPE, PHONE_NUMBER_FIELD_TYPE,
  PRICE_UNIT_FIELD_TYPE,
  required, requiredText,
  SELECT_FIELD_TYPE,
  STRING_FIELD_TYPE,
  TIME_FIELD_TYPE, validateNumbersOnly,
  VAT_FIELD_TYPE,
} from '../../../utils/form-utils';
import { CODE_CHAR_LENGTH, FONT_SIZE_OPTIONS, VAT_0 } from '../../../utils/adminstration-items-const';
import { COUNTRIES } from '../../../const/countries-const';
import AdministrationBookkeeping from './bookkeping/AdministrationBookkeeping';

export const ADMINISTRATION_WORKING = {
  urlPath: `${ADMINISTRATION_PAGE_URL}/working`,
  title: <FormattedMessage
    id="menu.main.administration.working-hours"
    defaultMessage="Working hours"
  />,
  type: ADMINISTRATION_DATA_TYPE.SCHEDULE_TIME_TABLE,
  serverName: 'AdministrationWorkingHours',
  fields: [
    {
      name: 'Name',
      label: <FormattedMessage id="administration.field.name" defaultMessage="Name" />,
      type: STRING_FIELD_TYPE,
      basic: true,
    },
    {
      name: 'Weight',
      label: <FormattedMessage id="administration.field.weight" defaultMessage="Weight" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'StartTime',
      label: <FormattedMessage id="administration.field.startTime" defaultMessage="Start Time" />,
      type: TIME_FIELD_TYPE,
    },
    {
      name: 'EndTime',
      label: <FormattedMessage id="administration.field.endTime" defaultMessage="End Time" />,
      type: TIME_FIELD_TYPE,
    },
    {
      name: 'StartDayOfWeek',
      label: <FormattedMessage id="administration.field.startDayOfWeek" defaultMessage="Start Day Of Week" />,
      type: DAY_FIELD_TYPE,
    },
    {
      name: 'EndDayOfWeek',
      label: <FormattedMessage id="administration.field.endDayOfWeek" defaultMessage="End Day Of Week" />,
      type: DAY_FIELD_TYPE,
    },
    {
      name: 'StartDate',
      label: <FormattedMessage id="administration.field.startDate" defaultMessage="Start Date" />,
      type: DATE_FIELD_TYPE,
    },
    {
      name: 'EndDate',
      label: <FormattedMessage id="administration.field.endDate" defaultMessage="End Date" />,
      type: DATE_FIELD_TYPE,
    },
  ],
};

export const ADMINISTRATION_ACCOUNTS = {
  urlPath: `${ADMINISTRATION_PAGE_URL}/accounts`,
  title: <FormattedMessage
    id="menu.main.administration.accounts"
    defaultMessage="Accounts"
  />,
  type: ADMINISTRATION_DATA_TYPE.ACCOUNT_TABLE,
  serverName: 'AdministrationAccounts',
  fields: [
    {
      name: 'Name',
      label: <FormattedMessage id="administration.field.name" defaultMessage="Name" />,
      type: STRING_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'AccountNumber',
      label: <FormattedMessage id="administration.field.accountNumber" defaultMessage="Account number" />,
      type: STRING_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'SieExportText',
      label: <FormattedMessage id="administration.field.sieExportText" defaultMessage="Sie Export Text" />,
      type: STRING_FIELD_TYPE,
    },
  ],
};

export const ADMINISTRATION_CUSTOMERS = {
  urlPath: `${ADMINISTRATION_PAGE_URL}/customers`,
  title: <FormattedMessage
    id="menu.main.administration.customers"
    defaultMessage="Customers"
  />,
  type: ADMINISTRATION_DATA_TYPE.CUSTOMER_TABLE,
  serverName: 'AdministrationCustomers',
  fields: [
    {
      name: 'CustomerCode',
      label: <FormattedMessage id="administration.field.customerCode" defaultMessage="Customer ID" />,
      helperText: <FormattedMessage id="administration.field.customerCode.helperText"
                                    defaultMessage="Customer ID for customer" />,
      type: CODE_FIELD_TYPE,
      basic: true,
      disabledOnUpdate: true,
      createCodeButton: true,
      validate: required,
    },
    {
      name: 'Name',
      label: <FormattedMessage id="administration.field.customerName" defaultMessage="Name" />,
      helperText: <FormattedMessage id="administration.field.customerName.helperText"
                                    defaultMessage="Name of the customer" />,
      type: STRING_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'OrganisationalNumber',
      label: <FormattedMessage id="administration.field.organisationalNumber" defaultMessage="Organisational number" />,
      helperText: <FormattedMessage id="administration.field.organisationalNumber.helperText"
                                    defaultMessage="Organisational number for customer - numbers only" />,
      type: CODE_FIELD_TYPE,
      basic: true,
    },
    {
      name: 'ContactName',
      label: <FormattedMessage id="administration.field.contactName" defaultMessage="Contact name" />,
      helperText: <FormattedMessage id="administration.field.contactName.helperText"
                                    defaultMessage="Name of the contact person" />,
      type: STRING_FIELD_TYPE,
      basic: true,
    },
    {
      name: 'Email',
      label: <FormattedMessage id="administration.field.emailAddress" defaultMessage="Email address" />,
      type: STRING_FIELD_TYPE,
      basic: true,
    },
    {
      name: 'PhoneNumber1',
      label: <FormattedMessage id="administration.field.phoneNumber" defaultMessage="Phone Number {number}"
                               values={{ number: 1 }} />,
      helperText: <FormattedMessage id="administration.field.phoneNumber.helperText"
                                    defaultMessage="Phone number {number} - numbers only" values={{ number: 1 }} />,
      type: PHONE_NUMBER_FIELD_TYPE,
      validate: validateNumbersOnly,
      basic: true,
    },
    {
      name: 'PhoneNumber2',
      label: <FormattedMessage id="administration.field.phoneNumber" defaultMessage="Phone Number {number}"
                               values={{ number: 2 }} />,
      helperText: <FormattedMessage id="administration.field.phoneNumber.helperText"
                                    defaultMessage="Phone number {number} - numbers only" values={{ number: 2 }} />,
      type: PHONE_NUMBER_FIELD_TYPE,
      validate: validateNumbersOnly,
      basic: true,
    },
    {
      name: 'StreetAddress',
      label: <FormattedMessage id="administration.field.streetAddress" defaultMessage="Street address" />,
      helperText: <FormattedMessage id="administration.field.streetAddress.helperText"
                                    defaultMessage="Street address of customer" />,
      type: STRING_FIELD_TYPE,
      basic: true,
    },
    {
      name: 'ZipCode',
      label: <FormattedMessage id="administration.field.zipCode" defaultMessage="Zip code" />,
      helperText: <FormattedMessage id="administration.field.zipCode.helperText"
                                    defaultMessage="Zip code of customer - numbers only" />,
      type: NUMBER_FIELD_TYPE,
      basic: true,
    },
    {
      name: 'City',
      label: <FormattedMessage id="administration.field.city" defaultMessage="City" />,
      helperText: <FormattedMessage id="administration.field.city.helperText" defaultMessage="City of customer" />,
      type: STRING_FIELD_TYPE,
      basic: true,
    },
    {
      name: 'Country',
      label: <FormattedMessage id="administration.field.country" defaultMessage="Country" />,
      helperText: <FormattedMessage id="administration.field.country.helperText"
                                    defaultMessage="Home country of customer" />,
      type: SELECT_FIELD_TYPE,
      options: COUNTRIES,
      initialValue: 'Sverige',
    },
    {
      name: 'Discount',
      label: <FormattedMessage id="administration.field.discountInPercent" defaultMessage="Discount in %" />,
      helperText: <FormattedMessage id="administration.field.discountInPercent.helperText"
                                    defaultMessage="Constant discount in % for customer (invoicing(membership purchase))" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'PaymentTermsDays',
      label: <FormattedMessage id="administration.field.paymentTermsDays" defaultMessage="Payment terms days" />,
      helperText: <FormattedMessage id="administration.field.paymentTermsDays.helperText"
                                    defaultMessage="Number of payment days from invoicing date" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'InternalComments',
      label: <FormattedMessage id="administration.field.internalComments" defaultMessage="Internal comments" />,
      helperText: <FormattedMessage id="administration.field.internalComments.helperText"
                                    defaultMessage="Internal comments visible for staff when invoicing" />,
      type: STRING_FIELD_TYPE,
      multiline: true,
    },
  ],
};

export const ADMINISTRATION_ARTICLES = {
  urlPath: `${ADMINISTRATION_PAGE_URL}/articles`,
  title: <FormattedMessage
    id="menu.main.administration.articles"
    defaultMessage="Articles"
  />,
  type: ADMINISTRATION_DATA_TYPE.INVENTORY_TABLE,
  serverName: 'AdministrationArticles',
  fields: [
    {
      name: 'Description',
      label: <FormattedMessage id="administration.field.itemName" defaultMessage="Item name" />,
      type: STRING_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'CategoryName',
      label: <FormattedMessage id="administration.field.category" defaultMessage="Category" />,
      type: SELECT_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'VisibleOnSalesMenu',
      label: <FormattedMessage id="administration.field.visibleOnSalesMenu" defaultMessage="Show in sales menu" />,
      type: BOOLEAN_FIELD_TYPE,
      basic: true,
      initialValue: true,
    },
    {
      name: 'ButtonColorHex',
      label: <FormattedMessage id="administration.field.buttonColor" defaultMessage="Button color" />,
      type: COLOR_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'ProductCode',
      label: <FormattedMessage id="administration.field.productCode" defaultMessage="Product code" />,
      type: CODE_FIELD_TYPE,
      basic: true,
      createCodeButton: true,
      validate: required,
    },
    {
      name: 'BarCode',
      label: <FormattedMessage id="administration.field.barCode" defaultMessage="Bar code" />,
      type: CODE_FIELD_TYPE,
      basic: true,
      createCodeButton: true,
      validate: required,
    },
    {
      name: 'Discount',
      label: <FormattedMessage id="administration.field.discount" defaultMessage="Discount" />,
      type: NUMBER_FIELD_TYPE,
      basic: true,
    },
    {
      name: 'QuantityInStockCurrent',
      label: <FormattedMessage id="administration.field.quantityInStockCurrent" defaultMessage="Quantity in stock" />,
      type: NUMBER_FIELD_TYPE,
      basic: true,
      initialValue: 0,
    },
    {
      name: 'PriceIncludingVat',
      label: <FormattedMessage id="administration.field.priceIncludingVat" defaultMessage="Price (incl. VAT)" />,
      type: NUMBER_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'VatPercentage',
      label: <FormattedMessage id="administration.field.vatPercentage" defaultMessage="VAT" />,
      type: VAT_FIELD_TYPE,
      basic: true,
      initialValue: VAT_0.value,
      validate: required,
    },
    {
      name: 'DictionaryTable',
      label: <FormattedMessage id="administration.field.dictionary" defaultMessage="Dictionary" />,
      helperText: <FormattedMessage id="administration.field.dictionary.helperText"
                                    defaultMessage="Name of dictionary" />,
      type: DICTIONARY_FIELD_TYPE,
      initialValue: 1,
      basic: true,
    },
    {
      name: 'SortingWeight',
      label: <FormattedMessage id="administration.field.salesMenuSorter" defaultMessage="SalesMenuSorter" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'AccountingType',
      label: <FormattedMessage id="administration.field.accountingType" defaultMessage="Accounting Type" />,
      type: SELECT_FIELD_TYPE,
      initialValue: 'Normal',
    },
    {
      name: 'PickupPriceIncludingVat',
      label: <FormattedMessage id="administration.field.pickupPriceIncludingVat"
                               defaultMessage="Pickup-price for item" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'PurchasePriceExcludingVat',
      label: <FormattedMessage id="administration.field.purchasePriceExcludingVat"
                               defaultMessage="Purchase price in SEK for item" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'SpecialFunctionTypeId',
      label: <FormattedMessage id="administration.field.specialFunctionType" defaultMessage="Special function type" />,
      helperText: <FormattedMessage id="administration.field.specialFunctionType.helperText"
                                    defaultMessage="Special functionality to occur when item is pressed" />,
      type: SELECT_FIELD_TYPE,
      initialValue: '1',
    },
    {
      // Visual only. Should not be editable. Show ONLY for items already added. Do not show when adding new items. This field explains when the items price was last changed.
      name: 'LastModifiedDateTime',
      label: <FormattedMessage id="administration.field.LastModifiedDateTime"
                               defaultMessage="Last modify date" />,
      type: STRING_FIELD_TYPE,
      disabled: true,
      onlyOnUpdate: true,
    },
    {
      name: 'IsSaleStopped',
      label: <FormattedMessage id="administration.field.salesStop" defaultMessage="Sales stop" />,
      helperText: <FormattedMessage id="administration.field.salesStop.helperText"
                                    defaultMessage="Activate to stop sales of this product" />,
      type: BOOLEAN_FIELD_TYPE,
      basic: true,
    },
    {
      name: 'PrintBongOnBongPrinter01',
      label: <FormattedMessage id="administration.field.printBongOnBongPrinter"
                               defaultMessage="Ticket on Printer{printerNumber}" values={{ printerNumber: '01' }} />,
      type: BOOLEAN_FIELD_TYPE,
    },
    {
      name: 'PrintBongOnBongPrinter02',
      label: <FormattedMessage id="administration.field.printBongOnBongPrinter"
                               defaultMessage="Ticket on Printer{printerNumber}" values={{ printerNumber: '02' }} />,
      type: BOOLEAN_FIELD_TYPE,
    },
    {
      name: 'PrintBongOnBongPrinter03',
      label: <FormattedMessage id="administration.field.printBongOnBongPrinter"
                               defaultMessage="Ticket on Printer{printerNumber}" values={{ printerNumber: '03' }} />,
      type: BOOLEAN_FIELD_TYPE,
    },
    {
      name: 'PrintBongOnBongPrinter04',
      label: <FormattedMessage id="administration.field.printBongOnBongPrinter"
                               defaultMessage="Ticket on Printer{printerNumber}" values={{ printerNumber: '04' }} />,
      type: BOOLEAN_FIELD_TYPE,
    },
    {
      name: 'PrintBongOnBongPrinter05',
      label: <FormattedMessage id="administration.field.printBongOnBongPrinter"
                               defaultMessage="Ticket on Printer{printerNumber}" values={{ printerNumber: '05' }} />,
      type: BOOLEAN_FIELD_TYPE,
    },
    {
      name: 'OnlyPrintBongIfExternalOrder',
      label: <FormattedMessage id="administration.field.onlyPrintBongIfExternalOrder"
                               defaultMessage="Print if weborder" />,
      type: BOOLEAN_FIELD_TYPE,
    },
    {
      name: 'BongCategoryName',
      label: <FormattedMessage id="administration.field.bongCategoryName" defaultMessage="Ticket category name" />,
      type: SELECT_FIELD_TYPE,
      initialValue: 'STANDARD',
    },
    {
      name: 'SupplierName',
      label: <FormattedMessage id="administration.field.supplierName" defaultMessage="Supplier of the item" />,
      type: STRING_FIELD_TYPE,
    },
    // {
    //   name: 'DictionaryTable',
    //   label: <FormattedMessage id="administration.field.dictionary" defaultMessage="Dictionary table" />,
    //   type: NUMBER_FIELD_TYPE,
    // },
    {
      name: 'ItemInfo',
      label: <FormattedMessage id="administration.field.itemInfo" defaultMessage="Item information" />,
      helperText: <FormattedMessage id="administration.field.itemInfo.helperText"
                                    defaultMessage="Detailed description of the item" />,
      type: STRING_FIELD_TYPE,
    },
    {
      name: 'DisplayItemInOtherCategory',
      label: <FormattedMessage id="administration.field.displayItemInOtherCategory"
                               defaultMessage="Display in extra category" />,
      type: MULTI_SELECT_FIELD_TYPE,
      disabled: true,
    },
    {
      name: 'PriceCalculationType',
      label: <FormattedMessage id="administration.field.priceCalculationType" defaultMessage="PriceCalculationType" />,
      type: SELECT_FIELD_TYPE,
      // initialValue: 'Ingen',
    },
    {
      name: 'PercentMarkupOnPurchasePrice',
      label: <FormattedMessage id="administration.field.percentMarkupOnPurchasePrice"
                               defaultMessage="Percentage markup" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'ComparisonPriceFactor',
      label: <FormattedMessage id="administration.field.comparisonPriceFactor"
                               defaultMessage="Comparison price factor" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'ComparisonPriceUnit',
      label: <FormattedMessage id="administration.field.comparisonPriceUnit" defaultMessage="Comparison price unit" />,
      type: PRICE_UNIT_FIELD_TYPE,
    },
    {
      name: 'PriceUnit',
      label: <FormattedMessage id="administration.field.priceUnit" defaultMessage="Comparison unit" />,
      type: STRING_FIELD_TYPE,
    },
    {
      name: 'RecyclingDepositAmountIncludingVat',
      label: <FormattedMessage id="administration.field.recyclingDepositAmountIncludingVat"
                               defaultMessage="Recycling price" />,
      helperText: <FormattedMessage id="administration.field.recyclingDepositAmountIncludingVat.helperText"
                                    defaultMessage="Deposit in SEK" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'QuantityInStockWarningLevel',
      label: <FormattedMessage id="administration.field.quantityInStockWarningLevel"
                               defaultMessage="Quantity in stock, warning level" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'BarCode2',
      label: <FormattedMessage id="administration.field.barCode.withNumber"
                               defaultMessage="Extra barcode for item {barcodeNumber}"
                               values={{ barcodeNumber: '2' }} />,
      type: STRING_FIELD_TYPE,
    },
    {
      name: 'BarCode3',
      label: <FormattedMessage id="administration.field.barCode.withNumber"
                               defaultMessage="Extra barcode for item {barcodeNumber}"
                               values={{ barcodeNumber: '3' }} />,
      type: STRING_FIELD_TYPE,
    },
    {
      name: 'BarCode4',
      label: <FormattedMessage id="administration.field.barCode.withNumber"
                               defaultMessage="Extra barcode for item {barcodeNumber}"
                               values={{ barcodeNumber: '4' }} />,
      type: STRING_FIELD_TYPE,
    },
    {
      name: 'BarCode5',
      label: <FormattedMessage id="administration.field.barCode.withNumber"
                               defaultMessage="Extra barcode for item {barcodeNumber}"
                               values={{ barcodeNumber: '5' }} />,
      type: STRING_FIELD_TYPE,
    },
    // {
    //   name: 'MultiPriceItem',
    //   label: <FormattedMessage id="administration.field.multiPriceItem" defaultMessage="MultiPriceItem" />,
    //   type: BOOLEAN_FIELD_TYPE,
    // },
    // {
    //   name: 'MultiPriceListId',
    //   label: <FormattedMessage id="administration.field.multiPriceListId" defaultMessage="MultiPriceListId" />,
    //   type: NUMBER_FIELD_TYPE,
    // },
    // {
    //   name: 'FixedQuantity',
    //   label: <FormattedMessage id="administration.field.fixedQuantity" defaultMessage="FixedQuantity" />,
    //   type: NUMBER_FIELD_TYPE,
    // },
  ],
};

export const ADMINISTRATION_CATEGORIES = {
  urlPath: `${ADMINISTRATION_PAGE_URL}/categories`,
  title: <FormattedMessage
    id="menu.main.administration.categories"
    defaultMessage="Categories"
  />,
  type: ADMINISTRATION_DATA_TYPE.CATEGORY_TABLE,
  serverName: 'AdministrationCategories',
  fields: [
    {
      name: 'Name',
      label: <FormattedMessage id="administration.field.categoryName" defaultMessage="Category name" />,
      helperText: <FormattedMessage id="administration.field.categoryName.helperText"
                                    defaultMessage="Name of the category" />,
      type: STRING_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'DefaultVatPercentage',
      label: <FormattedMessage id="administration.field.defaultVatPercentage"
                               defaultMessage="VAT" />,
      helperText: <FormattedMessage id="administration.field.defaultVatPercentage.helperText"
                                    defaultMessage="Standard VAT-rate" />,
      type: VAT_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    // {
    //   name: 'SalesMenuSorter',
    //   label: <FormattedMessage id="administration.field.salesMenuSorter" defaultMessage="Sales menu sorter" />,
    //   type: NUMBER_FIELD_TYPE,
    // },
    {
      name: 'ButtonColorHex',
      label: <FormattedMessage id="administration.field.buttonColorName" defaultMessage="Button color" />,
      helperText: <FormattedMessage id="administration.field.buttonColorName.helperText"
                                    defaultMessage="Color of physical button" />,
      type: COLOR_FIELD_TYPE,
      basic: true,
      initialValue: '#F0E68C',
    },
    {
      name: 'DisplaySubCategoryInventoryItems',
      label: <FormattedMessage id="administration.field.displaySubCategoryInventoryItems"
                               defaultMessage="Display subcategories" />,
      helperText: <FormattedMessage id="administration.field.displaySubCategoryInventoryItems.helperText"
                                    defaultMessage="Show products for subcategories under this category" />,
      type: BOOLEAN_FIELD_TYPE,
    },
    {
      name: 'AccountNumber',
      label: <FormattedMessage id="administration.field.accountNumber" defaultMessage="Account number" />,
      helperText: <FormattedMessage id="administration.field.accountNumber.helperText"
                                    defaultMessage="Account number for bookkeeping" />,
      type: ACCOUNT_NUMBER_FIELD_TYPE,
      validate: value => value && typeof value === 'number' && String(value).length === 4 ? undefined : 'Account number must be 4 digits long',
    },
    {
      name: 'ParentCategoryName',
      label: <FormattedMessage id="administration.field.parentCategoryName" defaultMessage="Parent category" />,
      helperText: <FormattedMessage id="administration.field.parentCategoryName.helperText"
                                    defaultMessage="Name of parent category" />,
      type: SELECT_FIELD_TYPE,
    },
    {
      name: 'AllowDiscount',
      label: <FormattedMessage id="administration.field.allowDiscount" defaultMessage="Allow discounts" />,
      helperText: <FormattedMessage id="administration.field.allowDiscount.helperText"
                                    defaultMessage="Allow or deny discounts" />,
      type: BOOLEAN_FIELD_TYPE,
      initialValue: true,
    },
    {
      name: 'AllowTakeaway',
      label: <FormattedMessage id="administration.field.allowTakeaway" defaultMessage="Allow takeaway" />,
      helperText: <FormattedMessage id="administration.field.allowTakeaway.helperText"
                                    defaultMessage="Allow or deny takeaway" />,
      type: BOOLEAN_FIELD_TYPE,
      initialValue: true,
    },
    {
      name: 'OnlyAllowCategories',
      label: <FormattedMessage id="administration.field.onlyAllowCategories" defaultMessage="Deny items" />,
      helperText: <FormattedMessage id="administration.field.onlyAllowCategories.helperText"
                                    defaultMessage="Use as main category without items" />,
      type: BOOLEAN_FIELD_TYPE,
    },
    {
      name: 'DefaultItemColor',
      label: <FormattedMessage id="administration.field.defaultItemColor" defaultMessage="Default button color" />,
      helperText: <FormattedMessage id="administration.field.defaultItemColor.helperText"
                                    defaultMessage="Default color of new items" />,
      type: COLOR_FIELD_TYPE,
      basic: true,
      initialValue: '#32CD32',
    },
    {
      name: 'BongCategories',
      label: <FormattedMessage id="administration.field.defaultBongCategoryName"
                               defaultMessage="Default bong category" />,
      helperText: <FormattedMessage id="administration.field.defaultBongCategoryName.helperText"
                                    defaultMessage="Default bong category of new items" />,
      type: SELECT_FIELD_TYPE,
      initialValue: 'STANDARD',
    },
    // {
    //   name: 'SalesMenuColumnCount',
    //   label: <FormattedMessage id="administration.field.salesMenuColumnCount"
    //                            defaultMessage="Sales menu column count" />,
    //   type: NUMBER_FIELD_TYPE,
    // },
    // {
    //   name: 'SalesMenuRowCount',
    //   label: <FormattedMessage id="administration.field.salesMenuRowCount" defaultMessage="Sales menu row count" />,
    //   type: NUMBER_FIELD_TYPE,
    // },
  ],
};

export const ADMINISTRATION_SUBCATEGORIES = {
  urlPath: `${ADMINISTRATION_PAGE_URL}/bongcategories`,
  title: <FormattedMessage
    id="menu.main.administration.subcategories"
    defaultMessage="Bongcategories"
  />,
  type: ADMINISTRATION_DATA_TYPE.BONG_CATEGORY_TABLE,
  serverName: 'AdministrationBongcategories',
  fields: [
    {
      name: 'Name',
      label: <FormattedMessage id="administration.field.name" defaultMessage="Name" />,
      helperText: <FormattedMessage id="administration.field.nameBongCategory.helperText"
                                    defaultMessage="Bong category for item" />,
      type: STRING_FIELD_TYPE,
      validate: required,
    },
    {
      name: 'BongSorter',
      label: <FormattedMessage id="administration.field.sortingWeight" defaultMessage="Sorting weight" />,
      helperText: <FormattedMessage id="administration.field.sortingWeight.helperText"
                                    defaultMessage="Sorting weight of kitchen category on kitchen ticket" />,
      type: NUMBER_FIELD_TYPE,
      validate: value => value === 0 ? 'Sorting weight cannot be set to 0' : value === '' ? 'Required' : undefined,
    },
    {
      name: 'ButtonColor',
      label: <FormattedMessage id="administration.field.colorInTableMap" defaultMessage="Color in tablemap" />,
      helperText: <FormattedMessage id="administration.field.colorInTableMap.helperText"
                                    defaultMessage="Color of kitchen category within table map for 'Begär fram'" />,
      type: COLOR_FIELD_TYPE,
    },
  ],
};

export const ADMINISTRATION_DICTIONARIES = {
  urlPath: `${ADMINISTRATION_PAGE_URL}/dictionaries`,
  title: <FormattedMessage
    id="menu.main.administration.dictionaries"
    defaultMessage="Dictionaries"
  />,
  type: ADMINISTRATION_DATA_TYPE.DICTIONARY_WORD_TABLE,
  serverName: 'AdministrationDictionaries',
  fields: [
    {
      name: 'Word',
      label: <FormattedMessage id="administration.field.word" defaultMessage="Dictionary word" />,
      helperText: <FormattedMessage id="administration.field.word.helperText"
                                    defaultMessage="Name of button for 'Bong info' window in sales menu" />,
      type: STRING_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'SortingWeight',
      label: <FormattedMessage id="administration.field.sortingWeight" defaultMessage="Sorting weight" />,
      helperText: <FormattedMessage id="administration.field.sortingWeight.helperText"
                                    defaultMessage="Sorting weight of kitchen category on kitchen ticket" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'DictionaryTable',
      label: <FormattedMessage id="administration.field.dictionary" defaultMessage="Dictionary" />,
      helperText: <FormattedMessage id="administration.field.dictionary.helperText"
                                    defaultMessage="Name of dictionary" />,
      type: DICTIONARY_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'Type',
      label: <FormattedMessage id="administration.field.type" defaultMessage="Type" />,
      type: NUMBER_FIELD_TYPE,
    },
    {
      name: 'FontSize',
      label: <FormattedMessage id="administration.field.fontSize" defaultMessage="Font size" />,
      helperText: <FormattedMessage id="administration.field.fontSize.helperText"
                                    defaultMessage="Font size of 'Bong info' -word." />,
      type: SELECT_FIELD_TYPE,
      options: FONT_SIZE_OPTIONS,
      initialValue: 15,
    },
    {
      name: 'NewLine',
      label: <FormattedMessage id="administration.field.newLine" defaultMessage="New line" />,
      helperText: <FormattedMessage id="administration.field.newLine.helperText"
                                    defaultMessage="Check if next 'Bong info'-word should be on a new line" />,
      type: BOOLEAN_FIELD_TYPE,
    },
  ],
};

export const ADMINISTRATION_BOOKEEPING = {
  urlPath: `${ADMINISTRATION_PAGE_URL}/bookeeping`,
  title: <FormattedMessage
    id="menu.main.administration.bookkeeping"
    defaultMessage="Bookkeeping"
  />,
  serverName: 'AdministrationBookkeeping',
  component: AdministrationBookkeeping,
};

export const ADMINISTRATION_VOUCHERS = {
  urlPath: `${ADMINISTRATION_PAGE_URL}/vouchers`,
  title: <FormattedMessage
    id="menu.main.administration.vouchers"
    defaultMessage="Vouchers"
  />,
  type: ADMINISTRATION_DATA_TYPE.GIFT_CARD_TABLE,
  serverName: 'AdministrationVouchers',
  fields: [
    {
      name: 'GiftCardCode',
      label: <FormattedMessage id="administration.field.giftCardCode" defaultMessage="Giftcard number" />,
      helperText: <FormattedMessage id="administration.field.giftCardCode.helperText"
                                    defaultMessage="Code of giftcard" />,
      type: CODE_FIELD_TYPE,
      basic: true,
      disabledOnUpdate: true,
      createCodeButton: true,
      validate: value => value && value.trim().length >= CODE_CHAR_LENGTH ? undefined : requiredText,
    },
    {
      name: 'CustomerCode',
      label: <FormattedMessage id="administration.field.customerCode" defaultMessage="Customer ID" />,
      helperText: <FormattedMessage id="administration.field.customerCode.helperText"
                                    defaultMessage="Customer ID number for customer." />,
      type: STRING_FIELD_TYPE,
    },
    {
      name: 'Balance',
      label: <FormattedMessage id="administration.field.balance" defaultMessage="Balance" />,
      helperText: <FormattedMessage id="administration.field.balance.helperText"
                                    defaultMessage="Balance of the giftcard" />,
      type: NUMBER_FIELD_TYPE,
      basic: true,
      validate: required,
      disabledOnUpdate: true,
    },
    {
      name: 'ValidFromDateTime',
      label: <FormattedMessage id="administration.field.validFromDateTime" defaultMessage="Valid from" />,
      helperText: <FormattedMessage id="administration.field.validFromDateTime.helperText"
                                    defaultMessage="From-date for giftcard" />,
      type: DATE_TIME_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'ValidToDateTime',
      label: <FormattedMessage id="administration.field.validToDateTime" defaultMessage="Valid to" />,
      helperText: <FormattedMessage id="administration.field.validToDateTime.helperText"
                                    defaultMessage="To-date for giftcard" />,
      type: DATE_TIME_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'Category',
      label: <FormattedMessage id="administration.field.category" defaultMessage="Category" />,
      type: STRING_FIELD_TYPE,
      validate: required,
      disabledOnUpdate: true,
    },
    {
      name: 'Description',
      label: <FormattedMessage id="administration.field.description" defaultMessage="Description" />,
      type: STRING_FIELD_TYPE,
      validate: required,
      disabledOnUpdate: true,
    },
    {
      name: 'IsActivated',
      label: <FormattedMessage id="administration.field.isActivated" defaultMessage="Activated" />,
      helperText: <FormattedMessage id="administration.field.isActivated.helperText"
                                    defaultMessage="Checked if giftcard is activated" />,
      type: BOOLEAN_FIELD_TYPE,
      basic: true,
      disabledOnUpdate: true,
    },
    {
      name: 'IsDeactivated',
      label: <FormattedMessage id="administration.field.isDeactivated" defaultMessage="Deactivated" />,
      helperText: <FormattedMessage id="administration.field.isDeactivated.helperText"
                                    defaultMessage="Checked if giftcard is deactivated" />,
      type: BOOLEAN_FIELD_TYPE,
      basic: true,
      disabledOnUpdate: true,
    },
    {
      name: 'IsEnabled',
      label: <FormattedMessage id="administration.field.isEnabled" defaultMessage="Enabled" />,
      helperText: <FormattedMessage id="administration.field.isEnabled.helperText"
                                    defaultMessage="Checked if giftcard is enable" />,
      type: BOOLEAN_FIELD_TYPE,
      disabledOnUpdate: true,
    },
  ],
};

export const ADMINISTRATION_BOOKKEEPING_CATEGORIES = {
  fields: [
    {
      name: 'Name',
      label: <FormattedMessage id="administration.field.categoryName" defaultMessage="Category name" />,
      helperText: <FormattedMessage id="administration.field.categoryName.helperText"
                                    defaultMessage="Name of the category" />,
      type: STRING_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'DefaultVatPercentage',
      label: <FormattedMessage id="administration.field.defaultVatPercentage"
                               defaultMessage="VAT" />,
      helperText: <FormattedMessage id="administration.field.defaultVatPercentage.helperText"
                                    defaultMessage="Standard VAT-rate" />,
      type: VAT_FIELD_TYPE,
      basic: true,
      validate: required,
    },
    {
      name: 'AccountNumber',
      label: <FormattedMessage id="administration.field.accountNumber" defaultMessage="Account number" />,
      helperText: <FormattedMessage id="administration.field.accountNumber.helperText"
                                    defaultMessage="Account number for bookkeeping" />,
      type: ACCOUNT_NUMBER_FIELD_TYPE,
      validate: value => value && typeof value === 'number' && String(value).length === 4 ? undefined : 'Account number must be 4 digits long',
    },
  ],
};

export const ADMINISTRATION_PAGES_LIST = [
  ADMINISTRATION_WORKING,
  ADMINISTRATION_ACCOUNTS,
  ADMINISTRATION_CUSTOMERS,
  ADMINISTRATION_ARTICLES,
  ADMINISTRATION_CATEGORIES,
  ADMINISTRATION_SUBCATEGORIES,
  ADMINISTRATION_DICTIONARIES,
  ADMINISTRATION_VOUCHERS,
  ADMINISTRATION_BOOKEEPING,
];